// Components==============
import React, { useContext } from 'react';
import { CalendarContext } from '../../Calendar';
import TextPlayer from '../TextPlayer/TextPlayer';
import './LogBook.module.scss';
// =========================

export default function LogBook() {
    const { activeLog } = useContext(CalendarContext);

    return (
        <>
            <div>
                <b>Opmerking ouder</b>
                {activeLog?.attributes?.fields
                    ?.filter((e) => e?.category_id === 3)
                    .map((e) => (
                        <TextPlayer
                            subTitle={e?.subTitle}
                            text={e?.text}
                            key={`${activeLog.key}${e.id}`}
                            id={e?.id}
                            shouldAuthenticate={false}
                        />
                    ))}
            </div>
            <div>
                <b>Lezen</b>
                <div styleName="playerWrapper">
                    {activeLog?.attributes?.fields
                        ?.filter((e) => e?.category_id === 1)
                        .map((e) => (
                            <TextPlayer
                                subTitle={e?.subTitle}
                                text={e?.text}
                                id={e?.id}
                                key={`${activeLog.key}${e.id}`}
                            />
                        ))}
                </div>
            </div>
            <div>
                <b>Spellen</b>
                <div styleName="playerWrapper">
                    {activeLog?.attributes?.fields
                        ?.filter((e) => e?.category_id === 2)
                        .map((e) => (
                            <TextPlayer
                                subTitle={e?.subTitle}
                                text={e?.text}
                                id={e?.id}
                                key={`${activeLog.key}${e.id}`}
                            />
                        ))}
                </div>
            </div>
        </>
    );
}
